import { render, staticRenderFns } from "./resumeManagement.vue?vue&type=template&id=4c554d34&scoped=true&"
import script from "./resumeManagement.vue?vue&type=script&lang=js&"
export * from "./resumeManagement.vue?vue&type=script&lang=js&"
import style0 from "./resumeManagement.vue?vue&type=style&index=0&id=4c554d34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c554d34",
  null
  
)

export default component.exports